/* 홈은 이제 비어 있다. 환영 문구를 걷어내고 그 자리에 은하수 음악대를 올렸다.
 * 음악대는 App 에서 renderContent 바깥에 놓여 있으므로 여기서 그리지 않는다.
 * (JSX 를 쓰지 않으므로 React 를 import 하지 않는다.) */
const Home = () => null;

export default Home;
